import { render, staticRenderFns } from "./FuncionarioProfile.vue?vue&type=template&id=feef0e4a"
import script from "./FuncionarioProfile.vue?vue&type=script&lang=js"
export * from "./FuncionarioProfile.vue?vue&type=script&lang=js"
import style0 from "./FuncionarioProfile.vue?vue&type=style&index=0&id=feef0e4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports